import { Create } from "react-admin"

import { TagForm } from "./TagForm"

export const TagCreate = () => (
  <Create redirect="/tags">
    <TagForm />
  </Create>
)
